import { useEffect } from 'react';

const API_BASE_URL = import.meta.env.VITE_CANCUN_API_URL;

// El favicon por defecto (palmera 🌴) vive como <link rel="icon"> en
// index.html porque es lo único que el navegador puede leer ANTES de que
// cargue el JS. Acá lo reemplazamos en caliente si el admin subió uno
// propio (config_key "favicon_url", editable en Marca dentro de
// ConfigPage.tsx) — si no hay ninguno subido, se queda la palmera.
const DynamicFavicon = () => {
  useEffect(() => {
    fetch(`${API_BASE_URL}/config`)
      .then((r) => r.json())
      .then((data) => {
        const url = data?.data?.favicon_url;
        if (!url) return;

        let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = url;
      })
      .catch(() => {});
  }, []);

  return null;
};

export default DynamicFavicon;
